import fromUnixTime from 'date-fns/fromUnixTime';
import format from 'date-fns/format';
import { saveAs } from 'file-saver';

export const downloadCsvFile = (fileName, content) => {
  const contentType = 'data:text/csv;charset=utf-8;';
  const blob = new Blob([content], { type: contentType });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.setAttribute('download', fileName);
  link.setAttribute('href', url);
  link.click();
  return link;
};

export const downloadXlsxFile = (fileName, content) => {
  const contentType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  const blob = new Blob([content], { type: contentType });
  saveAs(blob, fileName);
};

export const generateFileName = ({ type, to, businessHours = false }) => {
  let name = `${type}-report-${format(fromUnixTime(to), 'dd-MM-yyyy')}`;
  if (businessHours) {
    name = `${name}-business-hours`;
  }
  // console.log(type, name);
  if (type === 'agent') {
    return `${name}.xlsx`;
  }
  return `${name}.csv`;
};
